export const STEP_TABS = {
    GET_STARTED: "GET_STARTED",
    SELECT_NUMBER: "SELECT_NUMBER",
    NUMBER_ADDED: "NUMBER_ADDED"
};